export function validatePreorderForm(formState, cart, displayProducts, options) {
    const requirePickupDate = options?.requirePickupDate !== false;
    if (cart.length === 0)
        return { ok: false, message: '請至少選擇一個商品' };
    if (formState.deliveryMethod === 'store_pickup') {
        if (requirePickupDate && !formState.pickupDate)
            return { ok: false, message: '請選擇取貨時間' };
        if (!formState.customerName?.trim())
            return { ok: false, message: '請填寫取餐人姓名' };
        if (!formState.customerPhone?.trim() ||
            !/^09\d{8}$/.test(formState.customerPhone.trim()))
            return { ok: false, message: '請填寫正確的取餐人電話（09 開頭 10 碼）' };
    }
    if (formState.deliveryMethod === 'home_delivery' &&
        !formState.shippingAddress) {
        return { ok: false, message: '請填寫完整地址資訊' };
    }
    if (formState.deliveryMethod === 'convenience_store_pickup') {
        if (!formState.convenienceStoreInfo)
            return { ok: false, message: '請選擇超商門市' };
        if (!formState.customerName?.trim())
            return { ok: false, message: '請填寫取貨人姓名' };
        if (!formState.customerPhone?.trim() ||
            !/^09\d{8}$/.test(formState.customerPhone.trim()))
            return { ok: false, message: '請填寫正確的取貨人電話（09 開頭 10 碼）' };
    }
    for (const item of cart) {
        const product = displayProducts.find(p => p.productId === item.productId);
        if (!product)
            return { ok: false, message: `商品「${item.productName}」已不存在` };
        const hasVariants = Boolean(product.hasVariants ?? product.has_variants);
        if (hasVariants && !item.productVariantId)
            return {
                ok: false,
                message: `多規格品 ${product.productName ?? item.productName} 必須指定規格`,
            };
        const remaining = Number(product.remainingQuantity ?? product.supplyQuantity ?? 0);
        if (item.quantity > remaining)
            return { ok: false, message: `商品「${item.productName}」預購名額不足` };
    }
    return { ok: true };
}
/** 發票步驟驗證：信箱必填，依類型驗證統編／載具／愛心碼 */
export function validateInvoiceForm(formState) {
    const e = formState.email?.trim();
    if (!e)
        return { ok: false, message: '請填寫發票信箱（開立後寄送通知）' };
    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRe.test(e))
        return { ok: false, message: '請填寫正確的 Email 格式' };
    if (formState.invoiceType === 'company') {
        const t = formState.taxId?.trim();
        if (!t || !/^\d{8}$/.test(t))
            return { ok: false, message: '公司發票請填寫 8 碼統一編號' };
    }
    if (formState.invoiceType === 'donation') {
        const l = formState.loveCode?.trim();
        if (!l || !/^\d{3,7}$/.test(l))
            return { ok: false, message: '捐贈請填寫 3~7 碼愛心碼' };
    }
    if (formState.invoiceType === 'personal') {
        if (formState.carrierType === 'cellphone') {
            const c = formState.carrierNum?.trim();
            if (!c || !/^\/[A-Za-z0-9.-]{7}$/.test(c))
                return {
                    ok: false,
                    message: '手機條碼格式：/ 開頭加 7 碼英數字（如 /AB12345）',
                };
        }
        if (formState.carrierType === 'natural') {
            const c = formState.carrierNum?.trim();
            if (!c || !/^[A-Za-z]{2}\d{14}$/.test(c))
                return {
                    ok: false,
                    message: '自然人憑證格式：2 碼英文 + 14 碼數字',
                };
        }
    }
    return { ok: true };
}
export function calcCartTotal(cart) {
    return cart.reduce((s, c) => {
        const price = Number.isFinite(Number(c.productPriceTwd))
            ? Number(c.productPriceTwd)
            : 0;
        const qty = Number.isFinite(c.quantity) ? c.quantity : 0;
        return s + price * qty;
    }, 0);
}
